import React from "react";

import {ActionButton} from "../../../../designSystem/components/ActionButton";
import {LoadingView} from "../../../../designSystem/components/LoadingView";
import {useBsrsManagement} from "../../hooks/useBsrsManagement";

export const BsrsManagementFeature = ({ userToken }) => {
  const { isLoading, exportData } = useBsrsManagement({ userToken })

  if (isLoading)
    return <LoadingView />

  return (
    <div className="w-full m-auto text-center">
      <ActionButton
        onClick={exportData}
        label="匯出數據"
        variant="outline"
        iconName="fa-file-export"
      />
    </div>
  )
}